import { render } from "./error-notify.vue?vue&type=template&id=6945df46"
import script from "./error-notify.vue?vue&type=script&lang=js"
export * from "./error-notify.vue?vue&type=script&lang=js"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__